import type { IonInfiniteScrollCustomEvent } from '@ionic/core';
import { IonInfiniteScroll } from '@ionic/react';
import { LoadingSpinner } from '@tbitop/ui';

export type OnLoadMore = () => Promise<unknown>;

type LoadMoreProps = {
  hasMore: boolean;
  onLoadMore: OnLoadMore;
};

export const LoadMore = ({ hasMore, onLoadMore }: LoadMoreProps) => {
  const handleLoadMore = async (event: IonInfiniteScrollCustomEvent<void>) => {
    await onLoadMore();
    event.target.complete();
  };

  return (
    <IonInfiniteScroll
      onIonInfinite={handleLoadMore}
      threshold="100px"
      disabled={!hasMore}
    >
      <div className="flex items-center justify-center my-4">
        <LoadingSpinner />
      </div>
    </IonInfiniteScroll>
  );
};
